module.exports = __webpack_public_path__ + "media/honey-icons/icon-text-50441b6a.svg";